/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { TimezoneFieldItemEdit } from "./edit-item";

const TimezoneFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <TimezoneFieldItemEdit />
        </FieldListEditWrapper>
    );
};
TimezoneFieldEdit.displayName = "TimezoneFieldEdit";
export { TimezoneFieldEdit };
